import './DetailListItem.css';
import Container from 'react-bootstrap/Container';
import CardItem from '../CardItem/CardItem';

const DetailListItem = ({title, subtitle, description, thumbnail, status, onClick}) => {

    return (
        <div className="card-item-container" onClick={onClick} role='button' tabIndex={0}>
        <Container>
            <div className='image-text-container'>
                <div className='card-image-wrapper'>
                    <CardItem status={status} imageUrl={thumbnail}></CardItem>
                </div>
                <div>
                    <h1 className="card-title">{title}</h1>
                    {subtitle && <h2 className="card-subtitle">{subtitle}</h2>}
                    <p className="card-description">
                        {description}
                    </p>
                </div>


            </div>
        </Container>
    </div>
    );
};

export default DetailListItem;
